module.exports = __webpack_public_path__ + "assets/img/dayu_code.b58eb858.png";